import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import {
  MoreVert as MoreIcon,
  ChecklistOutlined as ListsIcon,
  UnfoldLessOutlined as CompactIcon,
  UnfoldMoreOutlined as DetailedIcon,
} from '@mui/icons-material';

/**
 * Menu "mais ações" do painel de leads, no TopBar à direita do filtro.
 * Ponto de entrada para controles do painel que não cabem como botão próprio.
 */
const LeadsTopBarMenu = ({ detailed, onToggleDetailed, onOpenLists }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const close = () => setAnchorEl(null);
  const run = (action) => () => {
    close();
    action();
  };

  return (
    <>
      <Tooltip title={t('leads.moreActions')}>
        <IconButton
          size="small"
          aria-label={t('leads.moreActions')}
          aria-haspopup="menu"
          aria-expanded={Boolean(anchorEl)}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        // O TopBar fica acima do conteúdo (zIndex 1300 no mobile): o menu precisa passar dele.
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        {/* O item mostra a ação: na visão detalhada, compactar; na compacta, detalhar. */}
        <MenuItem onClick={run(onToggleDetailed)}>
          <ListItemIcon>{detailed ? <CompactIcon fontSize="small" /> : <DetailedIcon fontSize="small" />}</ListItemIcon>
          <ListItemText
            primary={t(detailed ? 'leads.viewCompact' : 'leads.viewDetailed')}
            secondary={t(detailed ? 'leads.viewCompactDescription' : 'leads.viewDetailedDescription')}
          />
        </MenuItem>
        <MenuItem onClick={run(onOpenLists)}>
          <ListItemIcon><ListsIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={t('leads.lists.title')} secondary={t('leads.lists.menuDescription')} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default LeadsTopBarMenu;
